import React, { Fragment } from 'react';
import { Router, Route, Switch,Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// Routes
import { PrivateRoute } from '../shared/PrivateRoute/PrivateRoute';
import { AdminPrivateRoute } from '../shared/AdminPrivateRoute/AdminPrivateRoute';

import ChatWidget from '../components/Chat/ChatWidget';

// User pages
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import BokPricePage from '../pages/customer/BokPricePage';
import BidPricePage from '../pages/customer/BidPricePage';
import BokStatusPage from '../pages/customer/BokStatusPage';
import LabelPage from '../pages/customer/LabelPage';
import BookingPage from '../pages/BookingPage';
import NewBookingPage from '../pages/NewBookingPage';
import BookingLinesPage from '../pages/BookingLinesPage';
import BookingLineDetailsPage from '../pages/BookingLineDetailsPage';
import AllBookingsPage from '../pages/AllBookingsPage';
import BookingSetsPage from '../pages/BookingSets/BookingSetsList';
import BookingSetsViewPage from '../pages/BookingSets/BookingSetsView';
import UploadPage from '../pages/UploadPage';
import PodsPage from '../pages/PodsPage';
import ReportPage from '../pages/report/ReportPage';
import BokPage from '../pages/BokPage';
import FilesPage from '../pages/FilesPage';
import WarehouseLabelPage from '../pages/customer/WarehouseLabelPage';

// Admin pages
import Main from '../pages/admin/Main';
import Login from '../pages/admin/AdminViews/Login';
import Dashboard from '../pages/admin/AdminViews/Dashboard';
import TotalDeliveries from '../pages/admin/AdminViews/Chart/TotalDeliveries';
import OnTimeLateDeliveries from '../pages/admin/AdminViews/Chart/OnTimeLateDeliveries';
import DeliveriesByClient from '../pages/admin/AdminViews/Chart/DeliveriesByClient';

import EmailTemplates from '../pages/admin/AdminViews/EmailTemplates/EmailTemplates';
import AddEmailTemplates from '../pages/admin/AdminViews/EmailTemplates/AddEmailTemplates';
import EditEmailTemplates from '../pages/admin/AdminViews/EmailTemplates/EditEmailTemplates';
import Users from '../pages/admin/AdminViews/Users/Users';
import AddUser from '../pages/admin/AdminViews/Users/AddUser';
import EditUser from '../pages/admin/AdminViews/Users/EditUser';
import CronOptions from '../pages/admin/AdminViews/CronOptions/CronOptions';
import FreightProviders from '../pages/admin/AdminViews/FreightProviders/FreightProviders';
import AddFreightProviders from '../pages/admin/AdminViews/FreightProviders/AddFreightProviders';
import EditFreightProviders from '../pages/admin/AdminViews/FreightProviders/EditFreightProviders';
import StatusMapping from '../pages/admin/AdminViews/FreightProviders/StatusMapping';
import SqlQueries from '../pages/admin/AdminViews/SqlQueries';
import SqlQueriesAction from '../pages/admin/AdminViews/SqlQueries/SqlQueriesAction';
import PricingOnlyList from '../pages/admin/AdminViews/PricingOnly/List';
import PricingOnlyUpload from '../pages/admin/AdminViews/PricingOnly/Upload';
import PricingRuleList from '../pages/admin/AdminViews/PricingRule/List';
import PricingRuleUpload from '../pages/admin/AdminViews/PricingRule/Upload';
import PricingRuleStatus from '../pages/admin/AdminViews/PricingRule/Status';
import Vehicles from '../pages/admin/AdminViews/Vehicles/Vehicles';
import Timings from '../pages/admin/AdminViews/Timings/Timings';
import Availabilities from '../pages/admin/AdminViews/Availabilities/Availabilities';
import FPCosts from '../pages/admin/AdminViews/FP/Costs';
import Clients from '../pages/admin/AdminViews/Clients/Clients';
import AddClient from '../pages/admin/AdminViews/Clients/AddClient';
import EditClient from '../pages/admin/AdminViews/Clients/EditClient';
import ClientFP from '../pages/admin/AdminViews/ClientFP/ClientFP';
import AugmentAddress from '../pages/admin/AdminViews/AugmentAddress/AugmentAddress';
import AddAugmentAddress from '../pages/admin/AdminViews/AugmentAddress/AddAugmentAddress';
import EditAugmentAddress from '../pages/admin/AdminViews/AugmentAddress/EditAugmentAddress';
import ClientEmployees from '../pages/admin/AdminViews/ClientEmployees/ClientEmployees';
import AddClientEmployee from '../pages/admin/AdminViews/ClientEmployees/AddClientEmployee';
import EditClientEmployee from '../pages/admin/AdminViews/ClientEmployees/EditClientEmployee';
import QuickViewLogs from '../pages/admin/AdminViews/Logs/QuickView';
import DownloadLogs from '../pages/admin/AdminViews/Logs/Download';
import DMEDownloadLogs from '../pages/admin/AdminViews/DMELogs/Download';
import QuoteReport from '../pages/admin/AdminViews/Reports/QuoteReport';
import ActiveBookings from '../pages/admin/AdminViews/Chart/ActiveBookings';

// Customer Dashboard pages
import CustomerLogin from '../pages/admin/CustomerViews/Login';
import CustomerDashboard from '../pages/admin/CustomerViews/Dashboard';
import CustomerClientEmployees from '../pages/admin/CustomerViews/ClientEmployees/ClientEmployees';
import CustomerAddClientEmployee from '../pages/admin/CustomerViews/ClientEmployees/AddClientEmployee';
import CustomerEditClientEmployee from '../pages/admin/CustomerViews/ClientEmployees/EditClientEmployee';
import CustomerClientProductList from '../pages/admin/CustomerViews/ClientProduct/List';
import CustomerClientProductImport from '../pages/admin/CustomerViews/ClientProduct/Import';
import ClientRas from '../pages/admin/CustomerViews/ClientRas';
import ClientRasAction from '../pages/admin/CustomerViews/ClientRas/ClientRasAction';
import ClientSubClient from '../pages/admin/CustomerViews/ClientSubClient/List';


export const AppRouter = () => (
    <Router history={createBrowserHistory()}>
        <Fragment>
            <Header />
            <Switch>
                <Route exact path='/' component={HomePage} />
                <PrivateRoute exact path='/home' component={HomePage} />
                <Route exact path='/files' component={FilesPage} />
                <Route exact path='/login' component={LoginPage} />
                <Route exact path='/forgot-password' component={ForgotPasswordPage} />
                <Route path='/reset-password' component={ResetPasswordPage} />

                <Route exact path='/bok' component={BokPage} />
                <Route exact path='/price/:id' component={BokPricePage} />
                <Route exact path='/order/:id' component={BokPricePage} />
                <Route exact path='/bid/:id' component={BidPricePage} />
                <Route exact path='/bid-decline/:id' component={BidPricePage} />
                <Route exact path='/approve/:id' component={BidPricePage} />
                <Route exact path='/disapprove-hold/:id' component={BidPricePage} />
                <Route exact path='/disapprove-disposal/:id' component={BidPricePage} />
                <Route exact path='/confirm/:id' component={BidPricePage} />
                <Route exact path='/status/:id' component={BokStatusPage} />
                <Route exact path='/label/:id' component={LabelPage} />
                <PrivateRoute exact path='/warehouse-label' component={WarehouseLabelPage} />
                
                <PrivateRoute exact path='/booking' component={BookingPage} />
                <PrivateRoute exact path='/create-a-booking' component={NewBookingPage} />
                <PrivateRoute exact path='/bookinglines' component={BookingLinesPage} />
                <PrivateRoute exact path='/bookinglinedetails' component={BookingLineDetailsPage} />
                <PrivateRoute exact path='/allbookings' component={AllBookingsPage} />
                <PrivateRoute exact path='/bookingsets' component={BookingSetsPage} />
                <Route exact path='/labels/bulk-view/:id' component={BookingSetsViewPage} />
                <PrivateRoute exact path='/upload' component={UploadPage} />
                <PrivateRoute exact path='/pods' component={PodsPage} />
                <PrivateRoute exact path='/reports' component={ReportPage} />
                <Main>
                    <Route exact path='/admin' component={ Login } />
                    <Route exact path='/admin/login' component={ Login} />
                    <AdminPrivateRoute exact path='/admin/dashboard' component={Dashboard} />
                    <AdminPrivateRoute exact path='/admin/users' component={Users} />
                    <AdminPrivateRoute exact path='/admin/users/add' component={AddUser} />
                    <AdminPrivateRoute exact path='/admin/users/edit/:id' component={EditUser} />
                    <AdminPrivateRoute exact path='/admin/emails' component={EmailTemplates} />
                    <AdminPrivateRoute exact path='/admin/emails/add' component={AddEmailTemplates} />
                    <AdminPrivateRoute exact path='/admin/emails/edit/:id' component={EditEmailTemplates} />
                    <AdminPrivateRoute exact path='/admin/sqlqueries' component={SqlQueries} />
                    <AdminPrivateRoute exact path='/admin/sqlqueries/add' component={SqlQueriesAction} />
                    <AdminPrivateRoute exact path='/admin/sqlqueries/edit/:id' component={SqlQueriesAction} />
                    <AdminPrivateRoute exact path='/admin/sqlqueries/duplicate/:id' component={SqlQueriesAction} />
                    <AdminPrivateRoute exact path='/admin/crons' component={CronOptions} />
                    <AdminPrivateRoute exact path='/admin/providers' component={FreightProviders} />
                    <AdminPrivateRoute exact path='/admin/providers/add' component={AddFreightProviders} />
                    <AdminPrivateRoute exact path='/admin/providers/edit/:id' component={EditFreightProviders} />
                    <AdminPrivateRoute exact path='/admin/providers/statusmapping' component={StatusMapping} />
                    <AdminPrivateRoute exact path='/admin/pricing-only' component={PricingOnlyList} />
                    <AdminPrivateRoute exact path='/admin/pricing-only/upload' component={PricingOnlyUpload} />
                    <AdminPrivateRoute exact path='/admin/vehicles' component={Vehicles} />
                    <AdminPrivateRoute exact path='/admin/timings' component={Timings} />
                    <AdminPrivateRoute exact path='/admin/availabilities' component={Availabilities} />
                    <AdminPrivateRoute exact path='/admin/fp-costs' component={FPCosts} />
                    <AdminPrivateRoute exact path='/admin/pricing-rule' component={PricingRuleList} />
                    <AdminPrivateRoute exact path='/admin/pricing-rule/upload' component={PricingRuleUpload} />
                    <AdminPrivateRoute exact path='/admin/pricing-rule/status' component={PricingRuleStatus} />

                    <AdminPrivateRoute exact path='/admin/clients' component={Clients} />
                    <AdminPrivateRoute exact path='/admin/clients/add' component={AddClient} />
                    <AdminPrivateRoute exact path='/admin/clients/edit/:id' component={EditClient} />

                    <AdminPrivateRoute exact path='/admin/client-fp' component={ClientFP} />

                    <AdminPrivateRoute exact path='/admin/clientemployees' component={ClientEmployees} />
                    <AdminPrivateRoute exact path='/admin/clientemployees/add' component={AddClientEmployee} />
                    <AdminPrivateRoute exact path='/admin/clientemployees/edit/:id' component={EditClientEmployee} />
                    
                    <AdminPrivateRoute exact path='/admin/chart/totaldeliveries' component={TotalDeliveries} />
                    <AdminPrivateRoute exact path='/admin/chart/ontimelatedeliveries' component={OnTimeLateDeliveries} />
                    <AdminPrivateRoute exact path='/admin/chart/deliveriesbyclient' component={DeliveriesByClient} />
                    <AdminPrivateRoute exact path='/admin/chart/activebooking' component={ActiveBookings} />

                    <AdminPrivateRoute exact path='/admin/augmentaddress' component={AugmentAddress} />
                    <AdminPrivateRoute exact path='/admin/augmentaddress/add' component={AddAugmentAddress} />
                    <AdminPrivateRoute exact path='/admin/augmentaddress/edit/:id' component={EditAugmentAddress} />

                    <AdminPrivateRoute exact path='/admin/logs/quickview' component={QuickViewLogs} />
                    <AdminPrivateRoute exact path='/admin/logs/download' component={DownloadLogs} />

                    <AdminPrivateRoute exact path='/admin/dme_logs/download' component={DMEDownloadLogs} />

                    <AdminPrivateRoute exact path='/admin/reports/quote' component={QuoteReport} />

                    <Route exact path='/customerdashboard' component={ CustomerLogin } />
                    <Route exact path='/customerdashboard/login' component={ CustomerLogin} />
                    <AdminPrivateRoute exact path='/customerdashboard/dashboard' component={CustomerDashboard} />
                    <AdminPrivateRoute exact path='/customerdashboard/client-ras' component={ClientRas} />
                    <AdminPrivateRoute exact path='/customerdashboard/client-ras/add' component={ClientRasAction} />
                    <AdminPrivateRoute exact path='/customerdashboard/client-ras/edit/:id' component={ClientRasAction} />
                    <AdminPrivateRoute exact path='/customerdashboard/client-ras/duplicate/:id' component={ClientRasAction} />
                    <AdminPrivateRoute exact path='/customerdashboard/clientemployees' component={CustomerClientEmployees} />
                    <AdminPrivateRoute exact path='/customerdashboard/clientemployees/add' component={CustomerAddClientEmployee} />
                    <AdminPrivateRoute exact path='/customerdashboard/clientemployees/edit/:id' component={CustomerEditClientEmployee} />
                    <AdminPrivateRoute exact path='/customerdashboard/clientproducts' component={CustomerClientProductList} />
                    <AdminPrivateRoute exact path='/customerdashboard/clientproducts/import' component={CustomerClientProductImport} />
                    <AdminPrivateRoute exact path='/customerdashboard/client-subclients' component={ClientSubClient} />

                </Main>

                <Redirect to='/' />
            </Switch>
            <Footer />
            <ChatWidget />
        </Fragment>
    </Router>
);



// WEBPACK FOOTER //
// ./src/routers/AppRouter.js